var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorPageBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6149_38305)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#FFF9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.447 586.962L379.647 607.762L371.925 535.013L441.644 557.266L433.911 484.488L503.007 507.28",
    stroke: "#19223F",
    strokeWidth: 23.578,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48 578.105L367.68 598.905L359.958 526.156L429.677 548.409L421.954 475.66L491.039 498.423",
    stroke: "url(#paint0_linear_6149_38305)",
    strokeWidth: 23.578,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 1069.96C131.19 1035.65 145.462 994.251 179.779 977.53C214.096 960.81 255.491 975.081 272.211 1009.4C288.932 1043.72 274.66 1085.11 240.343 1101.83",
    stroke: "#19223F",
    strokeWidth: 46.2715,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.887 752.661L637.24 756.387L714.287 914.515L721.933 910.789L644.887 752.661Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.786 791.239L598.658 868.285L602.384 875.932L760.512 798.885L756.786 791.239Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.811 800.9L595.039 808.941L761.331 866.274L764.103 858.233L597.811 800.9Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.218 749.056L646.885 915.348L654.926 918.12L712.259 751.828L704.218 749.056Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.585 835.204L592.15 843.691L767.662 832.001L767.097 823.514L591.585 835.204Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.541 746.132L681.232 921.645L689.719 921.079L678.029 745.567L669.541 746.132Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.448 765.444L617.521 895.965L623.833 901.667L741.759 771.146L735.448 765.444Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.162 771.545L611.459 777.855L741.964 895.79L747.667 889.479L617.162 771.545Z",
    fill: "#19223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.42 674L1346.11 639.449L1321 627.613L1309.16 652.727L1274.61 726.036L1299.73 737.872L1334.28 664.563L1407.59 699.114L1419.42 674Z",
    stroke: "#231F20",
    strokeWidth: 2.85794,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.809 204.387L91.5001 169.836L66.3867 158L54.5506 183.113L19.9997 256.423L45.1132 268.259L79.6641 194.95L152.973 229.5L164.809 204.387Z",
    stroke: "#231F20",
    strokeWidth: 2.85794,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.82 406.055C1009.74 376.185 987.34 345.279 1003.06 316.651C1009.3 305.287 1019.58 296.415 1031.52 291.471C1044.37 286.155 1058.02 286.356 1070.8 291.63C1086.52 298.091 1099.88 309.519 1116.67 313.449C1124.61 315.296 1132.87 315.472 1140.57 312.554C1148.13 309.664 1154.2 303.868 1158.62 297.172C1167.96 283.086 1170.2 266.098 1176.48 250.702C1179.47 243.338 1183.56 236.35 1189.67 231.178C1196.82 225.119 1206.03 222.338 1215.17 221.062C1224.6 219.759 1234.17 219.979 1243.66 220.274C1253.03 220.553 1262.4 221.06 1271.72 221.855C1290.65 223.419 1309.46 225.986 1328.1 229.585C1332.73 230.47 1337.36 231.43 1341.99 232.467C1344.83 233.089 1346.36 228.784 1343.48 228.145C1324.65 223.996 1305.57 220.803 1286.42 218.704C1267.3 216.591 1247.86 215.204 1228.59 215.585C1219.14 215.762 1209.65 216.714 1200.67 219.878C1192.28 222.866 1185.02 228.072 1179.72 235.23C1169.69 248.746 1167.56 265.949 1161.55 281.286C1158.51 289.091 1154.46 296.856 1148.16 302.573C1141.98 308.155 1134.09 310.752 1125.82 310.317C1108.3 309.392 1094.03 298.062 1078.91 290.481C1071.8 286.908 1064.31 284.047 1056.34 283.235C1049.82 282.589 1043.15 283.19 1036.85 284.937C1023.92 288.471 1012.28 296.264 1004.06 306.816C1000.04 311.994 996.857 317.896 994.906 324.145C992.687 331.32 992.306 338.772 992.869 346.218C994.118 362.376 1000.08 377.942 1000.24 394.21C1000.28 398.091 999.95 401.998 999.196 405.81C998.696 408.589 1003.27 408.895 1003.82 406.055Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.57 407.727C1030.81 406.147 1032.16 402.237 1030.58 398.994C1029 395.75 1025.09 394.402 1021.85 395.982C1018.6 397.563 1017.26 401.473 1018.84 404.716C1020.42 407.959 1024.33 409.308 1027.57 407.727Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.6 383.681C1022.84 382.1 1024.19 378.19 1022.61 374.947C1021.03 371.703 1017.12 370.355 1013.88 371.936C1010.64 373.516 1009.29 377.426 1010.87 380.669C1012.45 383.913 1016.36 385.261 1019.6 383.681Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.98 359.286C1018.22 357.706 1019.57 353.795 1017.99 350.552C1016.41 347.309 1012.5 345.961 1009.26 347.541C1006.01 349.121 1004.67 353.032 1006.25 356.275C1007.83 359.518 1011.74 360.866 1014.98 359.286Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.05 335.766C1021.3 334.186 1022.64 330.276 1021.06 327.033C1019.48 323.789 1015.57 322.441 1012.33 324.022C1009.09 325.602 1007.74 329.512 1009.32 332.755C1010.9 335.999 1014.81 337.347 1018.05 335.766Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.25 315.286C1033.5 313.706 1034.84 309.795 1033.26 306.552C1031.68 303.309 1027.77 301.961 1024.53 303.541C1021.29 305.121 1019.94 309.032 1021.52 312.275C1023.1 315.518 1027.01 316.866 1030.25 315.286Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.11 309.954C1059.36 308.374 1060.71 304.463 1059.13 301.22C1057.55 297.977 1053.64 296.629 1050.39 298.209C1047.15 299.789 1045.8 303.699 1047.38 306.943C1048.96 310.186 1052.87 311.534 1056.11 309.954Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.49 320.556C1082.73 318.975 1084.08 315.065 1082.5 311.822C1080.92 308.578 1077.01 307.23 1073.76 308.811C1070.52 310.391 1069.17 314.301 1070.75 317.544C1072.33 320.788 1076.24 322.136 1079.49 320.556Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.87 330.52C1102.12 328.94 1103.47 325.03 1101.89 321.787C1100.31 318.543 1096.4 317.195 1093.15 318.775C1089.91 320.356 1088.56 324.266 1090.14 327.509C1091.72 330.752 1095.63 332.101 1098.87 330.52Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.75 336.009C1127.99 334.428 1129.34 330.518 1127.76 327.275C1126.18 324.032 1122.27 322.683 1119.02 324.264C1115.78 325.844 1114.43 329.754 1116.01 332.997C1117.59 336.241 1121.5 337.589 1124.75 336.009Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.9 333.485C1155.15 331.905 1156.5 327.995 1154.91 324.751C1153.33 321.508 1149.42 320.16 1146.18 321.74C1142.94 323.321 1141.59 327.231 1143.17 330.474C1144.75 333.717 1148.66 335.065 1151.9 333.485Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.1 316.376C1175.35 314.796 1176.7 310.885 1175.12 307.642C1173.54 304.399 1169.63 303.051 1166.38 304.631C1163.14 306.211 1161.79 310.121 1163.37 313.365C1164.95 316.608 1168.86 317.956 1172.1 316.376Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.45 288.825C1187.7 287.245 1189.05 283.335 1187.47 280.091C1185.89 276.848 1181.98 275.5 1178.73 277.08C1175.49 278.66 1174.14 282.571 1175.72 285.814C1177.3 289.057 1181.21 290.405 1184.45 288.825Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.13 259.821C1199.38 258.241 1200.73 254.331 1199.15 251.087C1197.57 247.844 1193.65 246.496 1190.41 248.076C1187.17 249.656 1185.82 253.567 1187.4 256.81C1188.98 260.053 1192.89 261.401 1196.13 259.821Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.22 240.673C1216.46 239.092 1217.81 235.182 1216.23 231.939C1214.65 228.696 1210.74 227.348 1207.5 228.928C1204.25 230.508 1202.91 234.418 1204.49 237.662C1206.07 240.905 1209.98 242.253 1213.22 240.673Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.1 239.376C1241.34 237.796 1242.69 233.885 1241.11 230.642C1239.53 227.399 1235.62 226.051 1232.37 227.631C1229.13 229.211 1227.78 233.121 1229.36 236.365C1230.94 239.608 1234.85 240.956 1238.1 239.376Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.89 239.47C1264.13 237.889 1265.48 233.979 1263.9 230.736C1262.32 227.493 1258.41 226.144 1255.17 227.725C1251.92 229.305 1250.58 233.215 1252.16 236.458C1253.74 239.702 1257.65 241.05 1260.89 239.47Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.91 241.813C1289.15 240.233 1290.5 236.323 1288.92 233.08C1287.34 229.836 1283.43 228.488 1280.19 230.068C1276.95 231.649 1275.6 235.559 1277.18 238.802C1278.76 242.045 1282.67 243.394 1285.91 241.813Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.12 244.716C1315.36 243.135 1316.71 239.225 1315.13 235.982C1313.55 232.739 1309.64 231.39 1306.39 232.971C1303.15 234.551 1301.8 238.461 1303.38 241.704C1304.96 244.948 1308.87 246.296 1312.12 244.716Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.46 250.446C1338.7 248.866 1340.05 244.956 1338.47 241.712C1336.89 238.469 1332.98 237.121 1329.74 238.701C1326.49 240.281 1325.14 244.192 1326.72 247.435C1328.3 250.678 1332.22 252.026 1335.46 250.446Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.902 62.4194C487.207 58.5482 488.635 46.9306 483.093 36.4708C477.55 26.011 467.134 20.67 459.829 24.5412C452.524 28.4125 451.095 40.0301 456.638 50.4899C462.181 60.9496 472.596 66.2907 479.902 62.4194Z",
    fill: "#C44EFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.471 22.7091L682.445 -93.3288C689.551 -97.0828 698.336 -94.3787 702.088 -87.3067L708.545 -75.0871C712.299 -67.9811 709.595 -59.1966 702.523 -55.4442L483.549 60.5937",
    stroke: "#19223F",
    strokeWidth: 6.12416,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.902 62.4194C487.207 58.5482 488.635 46.9306 483.093 36.4708C477.55 26.011 467.134 20.67 459.829 24.5412C452.524 28.4125 451.095 40.0301 456.638 50.4899C462.181 60.9496 472.596 66.2907 479.902 62.4194Z",
    stroke: "#19223F",
    strokeWidth: 6.12416,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.607 -76.1464C229.506 -49.0137 236.03 -11.5447 263.162 7.55637L332.309 -90.7017C305.177 -109.803 267.708 -103.279 248.607 -76.1464Z",
    fill: "url(#paint1_linear_6149_38305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6149_38305",
    x1: 292.36,
    y1: 530.348,
    x2: 501.636,
    y2: 537.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE1AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6149_38305",
    x1: 224.102,
    y1: -63.1039,
    x2: 341.645,
    y2: -89.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE87A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6149_38305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageBackground);
export default __webpack_public_path__ + "static/media/error_page_background.3f7ed85613d05833a9d893dde022c694.svg";
export { ForwardRef as ReactComponent };